











































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { namespace } from 'vuex-class';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
import { Image } from 'element-ui';
import event from '@acgn/herm/src/util/event';
const ComicAction = namespace('desk/comic').Action;
const ComicGetter = namespace('desk/comic').Getter;

@Component({
  components: {
    AcgnSearchWrap,
    AcgnTable,
    AcgnTopButton,
    AcgnProjectList,
    [Image.name]: Image
  }
})

/**
 * 项目，画手工作台列表
 */
export default class AcgnProjectList extends Vue {
  private chapter: any = ''; // 章节

  @ComicAction private searchCreateUser: any; // 获取用户id
  @ComicAction private delProject: any; // 删除项目
  @ComicAction private recoverProject: any; // 恢复项目
  @ComicGetter private loadings: any; // 漫画loading

  @Prop() private getData: any; // 项目方法
  @Prop() private isEdit: any; // 是否含有编辑按钮
  @Prop() private detailUrl: any; // 查看地址

  // 用户id
  private create_uid: any = '';

  // 列表配置
  private tableConfig: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        label: '项目名称',
        prop: 'name'
      },
      {
        label: '创建人名称',
        prop: 'dtalk_real_name'
      },
      {
        label: '项目图',
        prop: 'icon',
        render: (h: any, { row }: any) => (this as any).renderPic(row)
      },
      {
        label: '更新频率',
        prop: 'update_rate'
      },
      {
        label: '最近更新',
        prop: 'updated_time',
        render(h: any, { row }: any) {
          return h('span', setDateTimeStamp(row.updated_time, 'YYYY-MM-DD HH:mm:ss'));
        }
      },
      {
        minWidth: 100,
        label: '创建时间',
        prop: 'create_time',
        render(h: any, { row }: any) {
          return h('span', setDateTimeStamp(row.created_time, 'YYYY-MM-DD HH:mm:ss'));
        }
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const { status }: any = this.$getFormCache();
          const btns = [
            {
              icon: `ift-fee`,
              color: '#73c800',
              text: '编辑',
              type: 'edit',
              disabled: false,
              permission: ['1005'],
              to: {
                name: 'desk-comicAuthEdit',
                params: {
                  id: row.id
                }
              },
            },
            {
              icon: `ift-fee`,
              color: '#1195e4',
              text: '查看',
              type: 'edit',
              permission: [this.isEdit ? '1006' : '3004'],
              disabled: false,
              to: {
                name: this.detailUrl,
                params: {
                  id: row.id
                }
              },
            },
            {
              icon: `ift-fee`,
              color: status === -1 ? '#1195e4' : '#ff0000',
              text: status === -1 ? '恢复' : '删除',
              type: status === -1 ? 'recover' : 'delete',
              // permission: [this.isEdit ? '1006' : '3004'],
              disabled: false
            }
          ];
          if (!this.isEdit) {
            btns.shift();
            btns.pop();
          }
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                const { type } = item;
                const data = item.row;
                switch (type) {
                  case 'delete':
                    this.delete(data);
                    return false;
                  case 'recover':
                    this.recover(data);
                    return false;
                }
                // console.log(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  private searchForm: any = { // 头部筛选项
    name: '',
    create_user_name: '',
    page: 1
  };

  private comicStatus: any = 0;
  private loading: any = false;
  private options: any = [];

  private clearUser() {
    this.create_uid = '';
  }

  private async remoteMethod(query: any) {
    if (query !== '') {
      this.loading = true;
      const { result } = await this.searchCreateUser({searchVal: query});
      this.loading = false;
      this.options = result.filter((item: any) => {
        return item.dtalk_real_name.toLowerCase()
          .indexOf(query.toLowerCase()) > -1;
      });
    } else {
      this.options = [];
    }
  }

  private async created() {
    const cacheForm: any = this.$getFormCache();
    this.searchForm = { ...this.searchForm, ...cacheForm };
    if (cacheForm.status) {
      this.comicStatus = cacheForm.status;
    }
    if (this.searchForm.page) { // 如果有缓存页码，先赋值
      this.pageConfig.currentPage = this.searchForm.page;
    }
    setTimeout(() => {
      // 绑定刷新列表事件
      event.on('$updateComicList', (data: any) => {
        this.comicStatus = data;
        this.initSearh({ page: 1 });
      });
    }, 0);
  }

  private beforeDestroy() {
    event.off('$updateComicList');
  }

  private renderPic(row: any) {
    if (row.image) {
      return (
        <el-image src={row.image} preview-src-list={[row.image]} style="width:50px;height:50px;"></el-image>
      );
    }
  }

  // 删除
  private delete(row: any) {
    this.$confirm(`确认删除项目“${row.name}”`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const { result } = await this.delProject({ project_id: row.id});
      this.initSearh({ page: 1 });
      event.emit('$updateStatus');
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    }).catch(() => {});
  }

  // 恢复
  private recover(row: any) {
    this.$confirm(`确认恢复项目“${row.name}”`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const { result } = await this.recoverProject({ project_id: row.id});
      this.initSearh({ page: 1 });
      event.emit('$updateStatus');
      this.$message({
        type: 'success',
        message: '项目已恢复!'
      });
    }).catch(() => {});
  }

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private initSearh({ page }: { page: any }) {
    this.searchForm.create_uid = this.create_uid;
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      status: this.comicStatus,
      page,
      size: 30
    };
    this.getData(options).then((res: any) => {
      const { result, paging } = res;
      tableConfig.data = result.list;
      pageConfig.currentPage = paging.page;
      pageConfig.pageSize = paging.size;
      pageConfig.total = paging.total;

      const { page_size, ...args } = options;
      this.$setFormCache({ ...args });
    });
  }
}
